import { PaymentAPI, PaymentProvider, PrepareAndPollPaymentOptions } from '../../typings/Payment'
import preparePayment from './prepare-payment'
import confirmPaymentIntent from './confirm-payment-intent'
import pollPayment from './poll-payment'

const preparePaymentAndPoll = async (
  paymentProvider: PaymentProvider,
  paymentAPI: PaymentAPI,
  { orderId, lastPaymentAttempt, options, selectedPaymentMethod }: PrepareAndPollPaymentOptions,
) => {
  const { error, data } = await preparePayment(paymentAPI, {
    paymentId: options.payment.id,
    paymentMethodType: selectedPaymentMethod,
  })

  if (error) {
    return { wasSuccessful: false, error }
  }

  const clientSecret = data?.paymentIntent?.clientSecret

  if (!clientSecret) {
    throw new Error('No client secret was returned for prepare payment api')
  }

  const { error: stripeError } = await confirmPaymentIntent(paymentProvider, { ...options }, lastPaymentAttempt)

  if (stripeError) {
    return { wasSuccessful: false, error: stripeError.message }
  }

  return pollPayment(paymentAPI, { orderId, lastPaymentAttempt })
}

export default preparePaymentAndPoll
